import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { useShouldShowConsults } from 'hooks/useShouldShowConsultLink';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';

import consultPcSvg from 'assets/images/consults/consult-pc-mobile.svg';
import {
  ButtonColors,
  ButtonSizes,
  Card,
  LinkButton,
  Typography,
} from 'components';

import styles from './ConsultWidget.module.css';

type ConsultWidgetProps = {
  title?: string;
  /** Logical location of this widget, forwarded as the `source` property
   * on the 'Schedule Call Clicked' event (e.g. 'results_summary', 'action_plan'). */
  source?: string;
};

export const ConsultWidget = ({
  title = 'Need help?',
  source,
}: ConsultWidgetProps) => {
  const { currentKit, currentKitId } = useCurrentKitAndTinyAccount();
  const shouldShowConsultLink = useShouldShowConsults(currentKit);
  const { trackEvent } = useAnalytics();

  if (!currentKit || !shouldShowConsultLink) {
    return null;
  }

  return (
    <Card variant='wrapper' className={styles.card}>
      <div className={styles.content}>
        <div className={styles.imageContainer}>
          <img className={styles.image} src={consultPcSvg} alt='Video call' />
        </div>
        <div className={styles.rightColumn}>
          <div className={styles.textContainer}>
            <Typography
              variant='body-m'
              serif
              className={styles.textTitle}
              responsive
            >
              {title}
            </Typography>
            <Typography variant='body-xs'>
              Schedule a call with one of our specialists.
            </Typography>
          </div>

          <LinkButton
            label='Schedule call'
            href={`/results/${currentKitId}/consults/select-method`}
            color={ButtonColors.PURPLE}
            size={ButtonSizes.S}
            className={styles.scheduleButton}
            onClick={() => trackEvent('Schedule Call Clicked', { source })}
          />
        </div>
      </div>
    </Card>
  );
};
